/* global gapi */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { withRouter } from 'react-router';
import { GoogleLogin } from 'react-google-login';
import * as compose from 'lodash.flowright';

// styles icons and images
import { Row, Col } from 'react-bootstrap';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { FormControlLabel, Checkbox, Typography, Button } from '@material-ui/core';
import './login.style.css';
import Logo from '../../../images/logo.png';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPassword: false,
            checkedB: false,
            email: '',
            password: '',
            error: '',
            user: '',
            code: '',
            bearerTokenResponse: '',
            to: '',
            userType: '',
            loginFrom: 'local',

        }
    }
    componentDidMount() {
        if (localStorage.userType) {
            this.props.history.push({
                pathname: '/homepage',
                state: localStorage
            });
        }
        else if (localStorage.jwt) {
            this.props.history.push({
                pathname: '/homepage',
                state: localStorage.jwt
            });
        }
    }
    render() {
        const handleChangePassword = prop => event => {
            this.setState({ ...this.state, [prop]: event.target.value });
        };
        const handleChangeEmail = prop => event => {
            this.setState({ ...this.state, [prop]: event.target.value });
        };
        const handleClickShowPassword = () => {
            this.setState({ ...this.state, showPassword: !this.state.showPassword });
        };
        const handleMouseDownPassword = event => {
            event.preventDefault();
        };
        const handleChangeC = name => event => {
            this.setState({ ...this.state, [name]: event.target.checked });
        };
        const responseGoogle = (response) => {
            if (response.accessToken) {
                this.setState({ ...this.state, accessToken: response.accessToken });
                this.props.loginSocial({
                    variables: {
                        token: this.state.accessToken,
                        provider: "google"
                    }
                }).then((res) => {
                    // if not loged in before 
                    if (res.data.loginSocialite.user === null) {
                        this.props.history.push({
                            pathname: '/registration',
                            state: response
                        });
                    }
                    else {
                        this.setState({ ...this.state, error: res.data.loginSocialite.Status.message, user: res.data.loginSocialite.user, code: res.data.loginSocialite.Status.code, bearerTokenResponse: res.data.loginSocialite.BearerTokenResponse, userType: res.data.loginSocialite.user.typeName })
                        // localStorage.setItem('BearerToken',res.data.loginSocialite.BearerTokenResponse);
                        localStorage.setItem('jwt', JSON.stringify(res.data.loginSocialite));
                        this.props.history.push({
                            pathname: '/homepage',
                            state: this.state
                        });
                    }
                })
            }
        }
        return (
            <div className="container-custom">
                <ValidatorForm
                    onSubmit={e => {
                        e.preventDefault();
                        // if(ValidateEmail(this.state.email)){
                        this.props.login({
                            variables: {
                                email: this.state.email,
                                password: this.state.password
                            }
                        }).then((res) => {
                            if (res.data.login.user == null) {
                                this.setState({ ...this.state, error: res.data.login.Status.message })
                            }
                            else {
                                this.setState({ ...this.state, error: res.data.login.Status.message, user: res.data.login.user, code: res.data.login.Status.code, bearerTokenResponse: res.data.login.BearerTokenResponse, userType: res.data.login.user.typeName })
                                //localStorage.setItem('BearerToken',res.data.res.data.login.BearerTokenResponse);
                                // console.log(res.data.login);
                                localStorage.setItem('jwt', JSON.stringify(res.data.login));

                                this.props.history.push({
                                    pathname: '/homepage',
                                    state: this.state
                                });
                            }
                            if (this.state.checkedB === true) {
                                localStorage.setItem('userType', this.state.userType);
                            }
                        })
                            .catch((err) => 
                            {console.log(err)
                            this.setState({ ...this.state, error: "Check your internet connection" })});
                        // }
                    }}
                    className="container pt-10 pb-1" autoComplete="off">
                    <div className="pt-1 pb-3">
                        <img src={Logo} alt="spreago logo" width="150px" />
                    </div>
                    <div className="pb-3">
                        <Typography variant="h4" color="primary">Welcome Back</Typography>
                    </div>
                    <Row className="justify-content-md-center mt-3">

                    </Row>
                    <TextField
                        fullWidth
                        required
                        label="Email"
                        type="email"
                        color="primary"
                        variant="outlined"
                        value={this.state.email}
                        onChange={handleChangeEmail('email')}
                    />
                    <FormControl required fullWidth className="mt-3" variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={this.state.showPassword ? 'text' : 'password'}
                            value={this.state.password}
                            onChange={handleChangePassword('password')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            labelWidth={70}
                        />
                    </FormControl>
                    <div className="text-danger"><p>{this.state.error}</p></div>
                    <Row className="justify-content-md-center text-darkgrey">
                        <Col lg={5} xs={6} className="pr-0">
                            <FormControlLabel
                                className="d-inline-block"
                                control={
                                    <Checkbox
                                        checked={this.state.checkedB}
                                        onChange={handleChangeC('checkedB')}
                                        value="checkedB"
                                        label="Remember me"
                                        color="primary"
                                    />
                                }
                                label="Remember me"
                            />
                        </Col>
                        <Col lg={{ span: 4, offset: 3 }} xs={6} className="text-right">
                            <Typography className="d-inline-block mt-1 pt-1">
                                <Link to='/forgetPassword' className="text-darkgrey">
                                    Forgot Password?
                                </Link>
                            </Typography>
                        </Col>
                        <Col xs={6} className="mt-4">
                            <Button type="submit" size="large" className="btn-orange-gradiant w-100 pr-4 pl-4" variant="contained" to={this.state.to} >Login</Button>
                        </Col>
                        <Col xs={6} className="mt-4">
                            <Button type="button" size="large" className="btn-white-gradiant w-100 pr-4 pl-4" variant="contained"
                                onClick={e => {
                                    this.props.history.push({
                                        pathname: '/createAccount'
                                    });
                                }} color="secondary" >Sign up</Button>
                        </Col>
                        <div className="dividor-container mt-4"><span>Or</span></div>
                        <Col xs={12} className="col-md-auto text-center">
                            <GoogleLogin
                                className="btn-google rounded"
                                clientId="468100560729-50aef0qmq47uv5tm413g8l6ijqmrrego.apps.googleusercontent.com"
                                onSuccess={responseGoogle}
                                onFailure={responseGoogle}
                                cookiePolicy={'single_host_origin'}
                            />
                        </Col>
                    </Row>

                </ValidatorForm>
            </div>
        );
    }

}
const LOGIN = gql`
mutation( $email : Email ! $password : String ! ){
   login(data: {
     attempt:{
       email: $email
       password: $password 
     }
   }){
     BearerTokenResponse{
       access_token
       token_type
     }
     user{
        id
        name
        typeName
        company{
            id
            name
            website_url
            description
            logo{
                url
            }
        }
      }
     Status{
       message
       code
       check
       title
     }
   }
 }
`;

const LOGIN_SOCIAL = gql`
mutation( $token : String  $provider : String  ){
    loginSocialite(data: {
      SocialiteInput:{
        token : $token
        provider : $provider
      }
    }){
     BearerTokenResponse{
        access_token
        token_type
        }
      user{
        id
        name
        typeName
        company{
            id
            name
            website_url
            description
            logo{
                url
            }
        }
      }
      Status{
        message
        code
      }
    }
  }
`
export default compose(
    graphql(LOGIN, {
        name: 'login'
    }),
    graphql(LOGIN_SOCIAL, {
        name: 'loginSocial'
    })
)(withRouter(Login));